import { create, registerPlugin } from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

export default function replaceInputFile(input) {
  const isMobile = window.matchMedia('(max-width: 576px)').matches;

  registerPlugin(
    FilePondPluginFileValidateType,
    FilePondPluginFileValidateSize,
    FilePondPluginImagePreview,
  );

  return create(input, {
    multiple: true,
    type: 'file',
    storeAsFile: true,
    name: 'photos[]',
    allowReorder: false,
    maxFiles: 2,
    allowFileSizeValidation: true,
    maxFileSize: '10MB',
    allowFileTypeValidation: true,
    acceptedFileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
    fileValidateTypeLabelExpectedTypesMap: { 'image/jpeg': '.jpg .png .jpeg' },
    labelIdle:
      '<span class="filepond--label-action">Выберите файлы  <span class="text-danger">*</span></span>&nbsp;или перетяните их. <br> Не более 2 файлов. <br> Вес фото не должен превышать 10МБ',
    labelFileTypeNotAllowed: 'Неверный тип файла',
    fileValidateTypeLabelExpectedTypes: 'Ожидаемый формат файла {lastType}',
    labelInvalidField: 'Поле содержит неверные файлы',
    labelFileLoading: 'Загрузка',
    labelButtonRemoveItem: 'Удалить',
    labelInvalidType: 'Неверный формат',
    labelMaxFileSizeExceeded: 'Файл слишком большой',
    labelMaxFileSize: 'Файл превышает максимальный размер в 5МБ',
    imagePreviewMaxHeight: (isMobile) ? 90 : 120,
    imagePreviewMinHeight: (isMobile) ? 90 : 120,
    imagePreviewHeight: (isMobile) ? 90 : 120,
  });
}
